module.exports = __webpack_public_path__ + "static/media/avatar.f3f6c03a.jpeg";